import { z } from 'zod';

import { CompanyType } from 'src/api';

import { FormField } from './constants';

export const formValidationSchema = z.object({
  [FormField.email]: z.email('Invalid email').nonempty('Required'),
  [FormField.companyType]: z.enum(CompanyType),
});
